/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'ark.action.learnMoreAboutDataPolicy.common.text': 'Learn more about your data privacy with Atlassian',
  'ark.action.reasonsIntro.common.text':
    'We think {product} will improve your team’s productivity. The recommendation is based on:',
  'ark.action.undo.button.text': 'Undo',
};
